import { render, staticRenderFns } from "./TypeValidationForm.vue?vue&type=template&id=dd6584e8&scoped=true"
import script from "./TypeValidationForm.vue?vue&type=script&lang=js"
export * from "./TypeValidationForm.vue?vue&type=script&lang=js"
import style0 from "./TypeValidationForm.vue?vue&type=style&index=0&id=dd6584e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6584e8",
  null
  
)

export default component.exports